import * as swcHelpers from '@swc/helpers';
import * as React from 'react';

const DeliveryIndicatorContext = /*#__PURE__*/ React.createContext({});
const useDeliveryIndicator = ()=>React.useContext(DeliveryIndicatorContext)
;
function withDeliveryIndicator(Component) {
    const wrappedName = Component.displayName || Component.name || 'Component';
    const WithDeliveryIndicator = (props)=>{
         return React.createElement(DeliveryIndicatorContext.Consumer, null, (context)=>{
             return React.createElement(Component, swcHelpers.extends({}, props, {
                config: context === null || context === void 0 ? void 0 : context.config
            }));
        });
    };
    WithDeliveryIndicator.displayName = `WithDeliveryIndicator(${wrappedName})`;
    return WithDeliveryIndicator;
}

export { DeliveryIndicatorContext as default, useDeliveryIndicator, withDeliveryIndicator };
//# sourceMappingURL=context.js.map
